import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

interface PrintQRCodeProps {
  /** URL pública completa, com protocolo — é o que o QR codifica. */
  url: string;
}

/** O texto impresso dispensa o protocolo; o QR codifica a URL completa. */
const semProtocolo = (url: string): string => url.replace(/^https?:\/\//, '');

/**
 * Bloco de fim de matéria com QR code para a versão digital.
 *
 * Genérico de propósito — recebe a URL pronta e não sabe de content type.
 * Quem decide onde ele aparece é o `PrintFooter`.
 *
 * `fgColor`/`bgColor` são os defaults da própria lib, declarados aqui para
 * blindar contra mudança de default numa atualização: um QR que deixe de ser
 * preto sobre branco pode simplesmente não ser lido pela câmera.
 *
 * `width`/`height` em 100% sobrescrevem o `size` (128px) do `qrcode.react` —
 * o `otherProps` é espalhado depois dos defaults dele —, deixando o SVG
 * preencher o quadro em centímetros definido no SCSS.
 */
export const PrintQRCode: React.FC<PrintQRCodeProps> = ({ url }) => (
  <div className="mpf-print-qrcode">
    <div className="mpf-print-qrcode__code">
      <QRCodeSVG
        value={url}
        level="M"
        marginSize={4}
        fgColor="#000000"
        bgColor="#ffffff"
        width="100%"
        height="100%"
        aria-label="QR code com o endereço desta notícia"
      />
    </div>
    <div className="mpf-print-qrcode__body">
      <p className="mpf-print-qrcode__title">Leia a versão digital</p>
      <p className="mpf-print-qrcode__desc">
        Aponte a câmera do celular para o código e acesse a notícia completa,
        com links e atualizações.
      </p>
      <p className="mpf-print-qrcode__url">{semProtocolo(url)}</p>
    </div>
  </div>
);

export default PrintQRCode;
